<template lang="pug">
  tr.table__row(
    :class="{ 'table__row--deleted': item.deleted }"
  )
    td.table__cell {{ item.name | shortstr }}
    td.table__cell {{ getAnimalTypeName(item) | shortstr }}
    td.table__cell
      ui-number-input(
        :disabled="!hasPermission('group', 'change')"
        v-model="item.animal_count"
        @input="onAnimalCountChange")

    td.table__cell.table__cell--action
      v-btn(
        :disabled="!hasPermission('group', 'change')"
        icon
        @click="$emit('select', item)")
        v-icon(
          font-size="1"
          icon="cog")
</template>

<script>
import UiNumberInput from '@/components/ui/ui-number-input/UiNumberInput.vue'
import api from '@/api'

export default {
  name: 'GroupsTableRow',

  components: {
    UiNumberInput
  },

  props: {
    item: Object
  },

  data () {
    return {
      isMounted: false
    }
  },

  mounted () {
    this.$nextTick(() => {
      this.isMounted = true
    })
  },

  methods: {
    getAnimalTypeName (item) {
      return item.animal_type
        ? item.animal_type.name
        : '-'
    },

    onAnimalCountChange (newVal) {
      if (!this.isMounted) {
        return
      }

      const { id, ...payload } = this.item
      payload.animal_count = newVal
      api.groups.updateById(id, payload)
    }
  }
}
</script>
<style lang="scss" scoped>
.table__row--deleted {
  background: #ffebee;
  opacity: 0.7;
  
  .table__cell {
    color: #c62828;
  }
}
</style>